import React from 'react';

import AssignPackItem from './AssignPackItem';

export default function AssignPackItems({ packItems }) {
    return <tbody>{(!!packItems?.length && packItems.map((packItem, i) => <AssignPackItem packItem={packItem} key={i.toString()} />)) || <></>}</tbody>;
}
